// ** React Import
import React, { useState } from "react";

// ** service call
import { forgotPassword } from "../../../../services/auth.services";

// ** Icon
import { ReactComponent as CloseIcon } from "../../../../assets/images/svg/close.svg";
import { Check, X } from "react-feather";

// ** toast
import toast from "react-hot-toast";
import ToastContent from "../../../components/toast/toast";

//** you validatior
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

// ** Hook form
import { useForm, Controller } from "react-hook-form";

// ** Reactstrap Imports
import {
  Form,
  Input,
  Label,
  Button,
  Modal,
  ModalBody,
  FormFeedback,
} from "reactstrap";
import { getErrorMsg } from "../../../../common/ErrorMessages/errorMessage";

const ResetPasswordModal = ({ open, setOpen }) => {
  const [isLoading, setIsLoading] = useState(false);

  // ** ResetPassSchema
  const defaultreset = {
    resetPasswordEmail: "",
  };

  const resetPassSchema = yup.object({
    resetPasswordEmail: yup
      .string()
      .email("Please enter valid email address")
      .required("Email is Required")
      .max(60, "email should be not greater than 60 character")
      .trim()
      .typeError("Email is Required"),
  });

  const {
    reset,
    setError,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultreset, resolver: yupResolver(resetPassSchema) });

  const onSubmit = (data) => {
    setIsLoading(true);
    if (Object.values(data).every((field) => field.length > 0)) {
      forgotPassword(data.resetPasswordEmail)
        .then((res) => {
          setIsLoading(false);
          toast((t) => (
            <ToastContent
              t={t.id}
              message={res?.data.message}
              icon={<Check size={12} />}
            />
          ));
          reset();
          setOpen(false);
        })
        .catch((err) => {
          setIsLoading(false);
          reset();
          //   setOpen({ ...modal, data: "" });
          // toast((t) => (
          //   <ToastContent
          //     t={t.id}
          //     message={err.response?.data?.message}
          //     color="danger"
          //     icon={<X size={12} />}
          //   />
          // ));
          getErrorMsg(err);
        });
    } else {
      for (const key in data) {
        if (data[key].length === 0) {
          setError(key, {
            type: "manual",
          });
        }
      }
    }
  };

  return (
    <>
      <Modal
        isOpen={open}
        toggle={(prev) => setOpen(!prev)}
        className="modal-dialog-centered modal-sm Forgot-password-modal"
        onClosed={() => reset({})}
      >
        <ModalBody>
          <Form
            className="auth-login-form mt-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Button.Ripple
              onClick={(prev) => setOpen(!prev)}
              className="btn-icon rounded-circle"
              color="flat-success"
            >
              <CloseIcon />
            </Button.Ripple>
            <h2 className="resetText">Reset password</h2>
            <p>Enter you registered email address.</p>
            <div className="mb-2 mt-2">
              <Label className="form-label" for="resetPasswordEmail">
                Email*
              </Label>
              <Controller
                id="resetPasswordEmail"
                name="resetPasswordEmail"
                control={control}
                render={({ field }) => (
                  <Input
                    type="email"
                    placeholder="john@example.com"
                    invalid={errors?.resetPasswordEmail && true}
                    {...field}
                  />
                )}
              />

              {errors?.resetPasswordEmail ? (
                <FormFeedback>
                  {errors?.resetPasswordEmail.message}
                </FormFeedback>
              ) : null}
            </div>
            <Button
              disabled={isLoading}
              type="submit"
              color="primary"
              className="themeBtn"
            >
              Reset my password
            </Button>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ResetPasswordModal;
